import type { FolderDiagnosis } from "../../lib/folder";

export function PreflightResult({ diagnosis }: { diagnosis: FolderDiagnosis }) {
  const ready = diagnosis.kind !== "unsupported";
  const explanation = diagnosis.kind === "plain-static"
    ? "We found index.html, so this folder can open as a website. Doorway publishes the finished files without running project code from your folder."
    : diagnosis.explanation;
  return (
    <div className={`preflight ${ready ? "preflight-ready" : "preflight-fix"}`} role="status">
      <span aria-hidden="true">{ready ? "✓" : "↗"}</span>
      <div>
        <strong>{ready ? diagnosis.kind === "source-runtime" ? "Good: ready for Doorway connection review" : diagnosis.kind === "source-static" ? "Good: Doorway can build this" : "Good: your website is ready" : diagnosis.label}</strong>
        <p>{explanation}</p>
      </div>
    </div>
  );
}
